import ExpiredPointsSimpleView from './ExpiredPointsSimpleView'
export default ExpiredPointsSimpleView
